<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="app-copyable-text"
        role="button"
        tabindex="0"
        @click.stop="copy"
        @keydown.enter.stop="copy"
      >
        <slot>{{ displayValue }}</slot>
      </span>
    </template>

    <span>{{ displayValue }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppCopyableText',

  props: {
    value: {
      type: [String, Number],
      default: null,
    },

    label: {
      type: String,
      default: 'Texto',
    },
  },

  computed: {
    displayValue() {
      return this.value === null || this.value === undefined || this.value === '' ? '-' : String(this.value)
    },

    hasValue() {
      return this.displayValue !== '-'
    },
  },

  methods: {
    async copy() {
      if (!this.hasValue) return

      try {
        await navigator.clipboard.writeText(this.displayValue)
        this.showSuccessOnSnackbar(`${this.label} copiado.`)
      } catch (error) {
        this.showErrorOnSnackbar(`Erro ao copiar ${this.label.toLowerCase()}.`)
      }
    },
  },
}
</script>

<style scoped>
.app-copyable-text {
  display: inline-block;
  max-width: 100%;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  transition: color 0.2s ease;
}

.app-copyable-text:hover {
  color: var(--v-primary-base) !important;
}
</style>
